/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Light_Fish_DripInputs */

const fr_home_light_fish_drip = /** @type {(inputs: Home_Light_Fish_DripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du programe`)
};

/**

* @param {Home_Light_Fish_DripInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const home_light_fish_drip = /** @type {((inputs?: Home_Light_Fish_DripInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Light_Fish_DripInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_home_light_fish_drip(inputs)
});